import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-16.jpg'
import _imports_1 from '@/assets/images/user-17.jpg'
import _imports_2 from '@/assets/images/user-18.jpg'
import _imports_3 from '@/assets/images/user-19.jpg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = {
  class: "card-body p-4",
  style: {"padding-bottom":"0 !important"}
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-xxl-6 col-xl-6 col-sm-6" }
const _hoisted_5 = { class: "card bg-primary-div bg-opacity-10 border-primary-div border-opacity-10 rounded-3 mb-4 stats-box style-three" }
const _hoisted_6 = { class: "card-body p-4" }
const _hoisted_7 = { class: "d-flex justify-content-between flex-wrap gap-2 align-items-center" }
const _hoisted_8 = { class: "ps-0 mb-0 list-unstyled d-flex align-items-center" }
const _hoisted_9 = { class: "ms-m-15" }
const _hoisted_10 = { class: "ms-m-15" }
const _hoisted_11 = { class: "ms-m-15" }
const _hoisted_12 = { class: "ms-m-15" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mb-3 mb-lg-4" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Projects Overview")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"col-xxl-6 col-xl-6 col-sm-6\"><div class=\"card bg-primary bg-opacity-10 border-primary border-opacity-10 rounded-3 mb-4 stats-box style-three\"><div class=\"card-body p-4\"><div class=\"d-flex align-items-center mb-19\"><div class=\"flex-shrink-0\"><i class=\"material-symbols-outlined fs-40 text-primary\"> folder_open </i></div><div class=\"flex-grow-1 ms-2\"><span>Total Projects</span><h3 class=\"fs-20 mt-1 mb-0\">1235</h3></div></div><div class=\"d-flex justify-content-between flex-wrap gap-2 align-items-center\"><span class=\"fs-12\">Projects this month</span><span class=\"count up fw-medium ms-0\">+10%</span></div></div></div></div><div class=\"col-xxl-6 col-xl-6 col-sm-6\"><div class=\"card bg-danger bg-opacity-10 border-danger border-opacity-10 rounded-3 mb-4 stats-box style-three\"><div class=\"card-body p-4\"><div class=\"d-flex align-items-center mb-19\"><div class=\"flex-shrink-0\"><i class=\"material-symbols-outlined fs-40 text-danger\">stacks</i></div><div class=\"flex-grow-1 ms-2\"><span>Active Projects</span><h3 class=\"fs-20 mt-1 mb-0\">425</h3></div></div><div class=\"d-flex justify-content-between flex-wrap gap-2 align-items-center\"><span class=\"fs-12\">Projects this month</span><span class=\"count up fw-medium ms-0\">+5.75%</span></div></div></div></div><div class=\"col-xxl-6 col-xl-6 col-sm-6\"><div class=\"card bg-success bg-opacity-10 border-success border-opacity-10 rounded-3 mb-4 stats-box style-three\"><div class=\"card-body p-4\"><div class=\"d-flex align-items-center mb-19\"><div class=\"flex-shrink-0\"><i class=\"material-symbols-outlined fs-40 text-success\">assignment_turned_in</i></div><div class=\"flex-grow-1 ms-2\"><span>Finished Projects</span><h3 class=\"fs-20 mt-1 mb-0\">135</h3></div></div><div class=\"d-flex justify-content-between flex-wrap gap-2 align-items-center\"><span class=\"fs-12\">Projects this month</span><span class=\"count down fw-medium ms-0\">-15%</span></div></div></div></div>", 3)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"d-flex align-items-center mb-2\"><div class=\"flex-shrink-0\"><i class=\"material-symbols-outlined fs-40 text-primary-div\">group</i></div><div class=\"flex-grow-1 ms-2\"><span>Team Members</span><h3 class=\"fs-20 mt-1 mb-0\">65+</h3></div></div>", 1)),
              _createElementVNode("div", _hoisted_7, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "fs-12" }, "Hard Worker", -1)),
                _createElementVNode("ul", _hoisted_8, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("img", {
                          src: _imports_0,
                          class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                          alt: "user"
                        }, null, -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_9, [
                    _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                      default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createElementVNode("img", {
                          src: _imports_1,
                          class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                          alt: "user"
                        }, null, -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_10, [
                    _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createElementVNode("img", {
                          src: _imports_2,
                          class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                          alt: "user"
                        }, null, -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_11, [
                    _createVNode(_component_RouterLink, { to: "/my-profile" }, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("img", {
                          src: _imports_3,
                          class: "wh-34 lh-34 rounded-circle border border-1 border-color-white",
                          alt: "user"
                        }, null, -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_12, [
                    _createVNode(_component_RouterLink, {
                      to: "/users/users-list",
                      class: "wh-34 lh-34 rounded-circle bg-primary d-block text-center text-decoration-none text-white fs-12 fw-medium border border-1 border-color-white"
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode(" +55 ", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}